import { Pipe, PipeTransform } from '@angular/core';
import {
  Assessment,
  BbsData,
  BbsDataSet,
  BbtData,
  CustomData,
  FgaData,
  FgaDataSet,
  NhptData,
  SingleNumberDataSet,
  SubTestDataSet,
  TugData,
} from '../services/model';

@Pipe({
  name: 'assessmentScorePercent',
  standalone: true,
})
export class AssessmentScorePercentPipe implements PipeTransform {
  damageLevels = [
    { icf: 4, min: 96, max: 100, color: '#ff0000a8' }, // Schädigung voll ausgeprägt
    { icf: 3, min: 50, max: 95, color: '#f5363975' }, // Schädigung erheblich ausgeprägt
    { icf: 2, min: 25, max: 49, color: 'orange' }, // Schädigung mäßig ausgeprägt
    { icf: 1, min: 5, max: 24, color: '#cdb832bd' }, // Schädigung leicht ausgeprägt
    { icf: 0, min: 0, max: 4, color: 'lightgray' }, // Schädigung nicht vorhanden
  ];

  transform(assessment: Assessment, side: 'left' | 'right' | 'none' = 'none'): number {
    if (assessment.type === 'ARAT') {
      let score = this.getScore(assessment.scorePercentage);
      if (side === 'left') {
        score = this.getScore(assessment.scorePercentageLeft);
      }
      if (side === 'right') {
        score = this.getScore(assessment.scorePercentageRight);
      }
      return score > -1 ? score : -1;
    } else if (assessment.type === 'CUSTOM') {
      const data = assessment.data as CustomData;

      let score = data.custom.data[0].valueLeft ?? 0;
      if (side === 'left') {
        score = data.custom.data[0].valueLeft ?? 0;
      }
      if (side === 'right') {
        score = data.custom.data[0].valueRight ?? 0;
      }
      return score;
    } else if (assessment.type === 'BBT') {
      const data = assessment.data as BbtData;

      let value = -1;
      if (side === 'left') {
        value = data.bbt.data[0].valueLeft ?? -1;
      }
      if (side === 'right') {
        value = data.bbt.data[0].valueRight ?? -1;
      }
      if (value === -1) {
        // wenn unausgefüllt, liefert backend 1 zurück, muss aber unterscheiden ob unausgefüllt!
        return -1;
      } else {
        let score = this.getScore(data.bbt.score);
        if (side === 'left') {
          score = this.getScore(data.bbt.score_left);
        }
        if (side === 'right') {
          score = this.getScore(data.bbt.score_right);
        }
        console.log('chris score bbt', score);

        return score > -1 ? score : -1;
      }
    } else if (assessment.type === 'BBS') {
      const data = assessment.data as BbsData;
      const subTest: SubTestDataSet<BbsDataSet> = data.bbs;
      let score = 0;
      data.bbs.data.forEach(subSubTest => (score += subSubTest.score ?? 0));
      const averageScore = score / subTest.data.length;
      const icfScore = this.getScore(averageScore);

      return icfScore > -1 ? icfScore : -1;
    } else if (assessment.type === 'FGA') {
      const data = assessment.data as FgaData;
      const subTest: SubTestDataSet<FgaDataSet> = data.fga;
      // let score = 0;
      // data.fga.data.forEach(subSubTest => (score += subSubTest.score ?? 0));
      // const averageScore = score / subTest.data.length;
      const icfScore = this.getScore(subTest.score);

      return icfScore > -1 ? icfScore : -1;
    } else if (assessment.type === 'TUG') {
      const data = assessment.data as TugData;
      const subTest: SubTestDataSet<SingleNumberDataSet> = data.tug;
      const score = this.getScore(subTest.score);

      return score > -1 ? score : -1;
    } else if (assessment.type === 'NHPT') {
      const data = assessment.data as NhptData;
      let score = this.getScore(data.nhpt.score);
      if (side === 'left') {
        score = this.getScore(data.nhpt.score_left);
      }
      if (side === 'right') {
        score = this.getScore(data.nhpt.score_right);
      }
      return score > -1 ? score : -1;
    } else {
      return 0;
    }
  }

  hasValue(value: any): boolean {
    return value !== undefined && value !== null;
  }

  getScore(score: number | null | undefined): number {
    // umrechnung auf erfüllung statt Schädigung
    if (this.getPercent(score) < 0) {
      return -1;
    }
    return 100 - this.getPercent(score);

    // ehemals: icfScore zurückggeben...
    // return this.getIcf(this.getPercent(score));
  }

  getPercent(score: number | null | undefined): number {
    if (score !== undefined && score !== null && score > -1) {
      if (score <= 1 && score >= 0) {
        return Math.round(score * 100);
      } else {
        return -2;
      }
    } else {
      return -1;
    }
  }
  getIcf(score: number | null | undefined): number {
    if (score !== undefined && score !== null) {
      if (score === -2) {
        return -2;
      } else if (score === -1) {
        return -1;
      } else {
        for (const level of this.damageLevels) {
          if (score >= level.min && score <= level.max) {
            return level.icf;
          }
        }
      }

      return -1;
    } else {
      return -1;
    }
  }
}
